import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface User {
    id: number;
    name: string;
    surname: string;
    email: string;
    mobile: string;
    inviter_id: number | null;
    telegram_id: string | null;
    bank_account: string;
    bank_swift: string;
    bank_card: string;
    bep20: string | null;
    trc20: string | null;
    address: string;
    photo: string;
    heir_name: string | null;
    heir_surname: string | null;
    telegram_username: string | null;
    telegram_bot: string | null;
    instagram: string | null;
    facebook: string | null;
    roles: string[];
    is_admin: boolean;
    language: string;
    created_at: string;
    updated_at: string;
}

interface AuthState {
    user: User | null;
    isAuthenticated: boolean;
    token: string | null;
}

const initialState: AuthState = {
    user: null,
    isAuthenticated: false,
    token: null,
};

const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        setCredentials: (
            state,
            action: PayloadAction<{ user: User | null; token: string | null }>
        ) => {
            state.user = action.payload.user;
            state.token = action.payload.token;
            state.isAuthenticated = !!action.payload.user;
        },
        logout: (state) => {
            state.user = null;
            state.token = null;
            state.isAuthenticated = false;
        },
        setLanguage: (state, action: PayloadAction<string>) => {
            if (state.user) {
                state.user.language = action.payload;
            }
        },
    },
});

export const { setCredentials, logout, setLanguage } = authSlice.actions;
export default authSlice.reducer;
